// 共有 Amplify 設定の再エクスポート（実体は @new-cti/frontend-shared）。
export { configureAmplify } from '@new-cti/frontend-shared/auth/amplify-config';
